import { protectedLinksBanner } from "#web/assets";
import { SpinnerCentered } from "#web/components/common/SpinnerCentered/SpinnerCentered";
import { makeShop, ShopQuery } from "#web/components/shop/queries/shopQuery";
import { routeConfig } from "#web/configs/route";
import { api } from "#web/services/api";
import { i18nLike } from "#web/services/i18nLike";
import { AutoTable } from "@gadgetinc/react/auto/polaris";
import { Banner, Page } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const en = {
  columns: {
    id: "ID",
    link: "Link",
    orderCount: "Order count",
    visitorCount: "Visitor count",
  },
  createLink: "Create link",
  dashboard: "Dashboard",
  error: {
    description: "Please try again later. If the issue persists, please contact support.",
    title: "Error loading page",
  },
  subtitle:
    "Use protected links to distribute high risk codes safely. Codes can only be applied when using the provided link (Can't be leaked to coupon sites/extensions) - Use cases for Protected links: Codes for employees, VIP customers, Influencers to try product, investors, etc.",
  title: "Protected Links",
};

export const LinkBlockingList = () => {
  const t = i18nLike(en);
  const navigate = useNavigate();
  const { data: shopData, isError: shopError, isFetching: shopFetching } = useQuery(ShopQuery());
  const shop = shopData ? makeShop(shopData) : null;

  return (
    <Page
      backAction={{
        content: t("dashboard"),
        onAction: () => {
          navigate(routeConfig["/"]);
        },
      }}
      primaryAction={{
        content: t("createLink"),
        onAction: () => {
          navigate(routeConfig.linkblocking.create["/"]);
        },
      }}
      subtitle={t("subtitle")}
      title={t("title")}
    >
      {shopError ? (
        <Banner title={t("error.title")} tone="critical">
          {t("error.description")}
        </Banner>
      ) : shopFetching ? (
        <SpinnerCentered />
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <img src={protectedLinksBanner} style={{ borderRadius: "0.5rem", width: "100%" }} />
          <AutoTable
            columns={[
              {
                field: "id",
                header: t("columns.id"),
              },
              {
                field: "link",
                header: t("columns.link"),
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                render: ({ record }) => `${shop?.domain ?? ""}/?code=${String(record.code)}`,
              },
              {
                field: "visitorCount",
                header: t("columns.visitorCount"),
              },
              {
                field: "orderCount",
                header: t("columns.orderCount"),
              },
            ]}
            emptyState={<div style={{ paddingBlock: "5rem", textAlign: "center" }}>No protected links available.</div>}
            filter={{
              shopId: { equals: shop?.id },
            }}
            initialSort={{ updatedAt: "Ascending" }}
            model={api.discountLinks}
            onClick={(row) => {
              // @ts-expect-error type issue
              navigate(routeConfig.linkblocking[":id"]["/"].replace(":id", row["id"]));
            }}
            paginate={true}
          />
        </div>
      )}
    </Page>
  );
};
